import { ReceiptLong } from '@mui/icons-material';
import { EinvoicingIntegrationPage } from '../modules/einvoicing-integration';
import { RouteType } from './types';
import { routePaths } from './routePaths';

const EinvoicingIntegration: RouteType = {
  exact: true,
  icon: ReceiptLong,
  path: routePaths.einvoicingIntegration,
  title: 'E-invoicing (SK)',
  component: () => <EinvoicingIntegrationPage />,
};

export default EinvoicingIntegration;
